<template>
  <div class="salaryHeader container">
 
    <!-- ---------------------------------------  Salary Header List -------------------------------------------------- -->

	<div align="center">
		<label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
		<scale-loader :loading="loading"></scale-loader>
	</div>

	<vue-good-table :columns="colSalary" :rows="rowSalary"
							:pagination-options="pagination_options" :lineNumbers="true"
							@on-row-click="rowChanged"  max-height="500px"
							:selectOptions="{
									enabled: true,
									selectOnCheckboxOnly: false, 
							}">
			<div v-show="allowNewReport" slot="table-actions">
				<CButton color="primary" class="ml-2 mr-3" v-on:click.prevent="serverCall('generateSalaryReport')">
                	Generate New Pay Report
            	</CButton>
				<!-- <CButton color="primary" class="mr-3" v-on:click.prevent="serverCall('generateAdvanceReport')">
                	Generate Advance
            	</CButton> -->
			</div>
			<div slot="selected-row-actions">
				<CButton color="info" class="ml-2 mr-3"  v-on:click.prevent="openSalaryDetails()">
                	Detailed Report
            	</CButton>
				<CButton v-show="isApproved==false" color="info" class="ml-2 mr-3" v-on:click.prevent="serverCall('deleteSalaryReport')">
                	Delete
            	</CButton>
				<CButton v-show="isApproved==false" color="info" class="ml-2 mr-3" :disabled="isApproved" v-on:click.prevent="serverCall('approveSalaryReport')">
                	Approve
            	</CButton>
				<CButton v-show="isApproved==true" color="info" class="ml-2 mr-3" :disabled="isApproved==false" v-on:click.prevent="serverCall('unApproveSalaryReport')">
                	UnApprove
            	</CButton>
			</div>
	</vue-good-table>

	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import ScaleLoader from "@/views/utils/ScaleLoader";
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'salaryHeader',

    components: {
        ScaleLoader,
    },
		
	data () {
		return {
			alert: '',
            loading: false,
			loadingMsg: null,
			
			salaryHeader: [],

			colSalary: [
					{
							label: 'Type',
							field: 'type',
							filterOptions: {
                                    enabled: true, 
                                },
					},
					{
							label: 'Report Date',
							field: 'createDate',
							html: false
					},
					{
							label: 'Start Date',
							field: 'startDate',
							filterOptions: {
                                    enabled: true, 
                                },
					},
					{
							label: 'End Date',
							field: 'endDate',
							filterOptions: {
                                    enabled: true, 
                                },
					},
					{
							label: 'Approved?',
							field: 'approved',
							html: false
					},
					{
							label: 'Approval Date',
							field: 'approvalDate',
							html: false
					},
					{
							label: 'Approval By',
							field: 'approvedBy',
					},
			],

            pagination_options: {
                enabled: true,
                mode: 'records',
                perPage: 5,
                position: 'top',
                perPageDropdown: [10, 20, 30, 40],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            },

			rowSalary: [],
			curRowSelected: null,
			isApproved: false,
			allowNewReport: false,
		}
	},

	computed: {
	},

	mounted(){
		this.serverCall('getSalaryHeader')	
	},

	methods: {
        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getSalaryHeader":
								self.getSalaryHeader(idToken, org)
								break;
							case "generateSalaryReport":
								self.generateSalaryReport('Salary', idToken, org)
								break;
							case "generateAdvanceReport":
								self.generateSalaryReport('Advance', idToken, org)
								break;
							case "deleteSalaryReport":
								self.deleteSalaryReport(idToken, org)
								break;
							case "approveSalaryReport":
								self.approveSalaryReport(true, idToken, org)
								break;
							case "unApproveSalaryReport":
								self.approveSalaryReport(false, idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})

		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row

			if (this.curRowSelected.approved=="Yes")
				this.isApproved = true
			else
				this.isApproved = false
		},

		// Open SalaryDetails
		openSalaryDetails(){
            var self = this
			self.alert = null

            // Check if SlaryHeader is selected
			if (self.curRowSelected==null){
				self.alert = "SalaryReport not selected."
				return
			}

			self.$router.push({ name: 'Pay Report Details', 
								params: { 'salaryHeaderDocId': self.curRowSelected.salaryHeaderDocId,
										   'createDate': self.curRowSelected.createDate,
										   'startDate': self.curRowSelected.startDate,
										   'endDate': self.curRowSelected.endDate,
										   'approved': self.curRowSelected.approved,
										} 
							 })
		},


        // Fetch salary header data for the given org
        getSalaryHeader(authToken, org) {
            var self = this
			self.alert = null
 
			// Set loading message
			self.loading = true
			self.loadingMsg = "Fetching Salary Reports..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/getSalaryHeader/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
						console.log("getSalaryHeader - error")
					}
					else {
						self.rowSalary = response.data.salaryHeaderList

						if (response.data.salaryHeaderList.length == 0){
							self.allowNewReport = true
						}
						else {
							self.allowNewReport = false
							self.$set(self.rowSalary[0], 'vgtSelected', true)
							self.curRowSelected = self.rowSalary[0]
						}
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					self.alert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

        // Generate Statements - Salary and Advance
        generateSalaryReport(payType, authToken, org) {
            var self = this
			self.alert = null

			var formData = new FormData();
			formData.append("payType", payType)

			// Set loading message
			self.loading = true
			self.loadingMsg = "Generating " + payType + " Statement..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/generateSalaryReport/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Fetch Salary Header records again
						self.serverCall('getSalaryHeader')
					}
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
				.catch(function (error) {
					self.alert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})		
		},

		// Delete Salary Report
		deleteSalaryReport(authToken, org){
			var self = this

			var formData = new FormData();
			formData.append("salaryHeaderDocId", self.curRowSelected.salaryHeaderDocId)

            // Check if record is selected
			if (self.curRowSelected==null){
				self.alert = "Salary report is not selected."
				return
			}
 
			// Set loading message
			self.loading = true
			self.loadingMsg = "Deleting Salary Report..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/deleteSalaryReport/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh Salary Report list on the screen
						self.serverCall('getSalaryHeader')
					}		
					// Reset loading message
					self.loading = false
					self.loadingMsg = null		
				})
				.catch(function (error) {
					self.userAlert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

		// if approveFlag = true, Approve Salary Report
		// else unApprove Salary Report
		approveSalaryReport(approveFlag, authToken, org){
			var self = this
			
            // Check if record is selected
			if (self.curRowSelected==null){
				self.alert = "Salary report is not selected."
				return
			}

			if (self.curRowSelected.approved=="Yes" && approveFlag==true){
				self.alert = "Report is already approved."
				return
			}
			else if (self.curRowSelected.approved=="No" && approveFlag==false){
				self.alert = "Report is already unApproved."
				return
			}

			var callUrl = ''
			if (approveFlag)
				callUrl = '/approveSalaryReport/'
			else
				callUrl = '/unApproveSalaryReport/'

			var formData = new FormData();
			formData.append("salaryHeaderDocId", self.curRowSelected.salaryHeaderDocId);
 
			// Set loading message
			self.loading = true
			self.loadingMsg = "Changing Approval Status..."

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: callUrl,
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh Salary Report list on the screen
						self.serverCall('getSalaryHeader')	
					}		
					// Reset loading message
					self.loading = false
					self.loadingMsg = null		
				})
				.catch(function (error) {
					self.userAlert = String(error)
					// Reset loading message
					self.loading = false
					self.loadingMsg = null
				})
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
